
<mat-chip-set aria-label="Fish selection">
  @for (filterSet of filterSets; track filterSet) {
    <mat-chip
      (click)="chipClick(filterSet)"
      [class.selected]="filterSet.id == selectedId">
      {{filterSet.name}}
    </mat-chip>
  }
</mat-chip-set>